/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import * as styles from "./HeroSection.module.css";
import heroSectionCover from "../../../images/on-going-projects/enchanted/Images/Entry-Gate-View-Image.jpg";
import enchantedLogo from "../../../images/on-going-projects/enchanted/Logos/enchanted-logo.png";
import heroBg from "../../../images/on-going-projects/enchanted/Icons/hero-section-bg.png";
import ReraModal from "./ReraModal";
import reraPdfUrl1 from "../../../images/on-going-projects/enchanted/rera-letter-1.jpg";
import reraPdfUrl2 from "../../../images/on-going-projects/enchanted/rera-letter-2.jpg";
import playIcon from "../../../images/on-going-projects/enchanted/play-icon-2.png";
import VideoModal from "./VideoModal";
import coverVideo from "../../../images/on-going-projects/enchanted/enchanted-cover-1.mp4";
import BrochureModal from "./BrochureModal";
import brochurePdfUrl from "../../../images/on-going-projects/enchanted/main-brochure.pdf";

function HeroSection() {
  const [showReraModal, setShowReraModal] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [showBrochureModal, setShowBrochureModal] = useState(false);
  const brochurePdfUrlRef = useRef(null);
  const videoUrl = "https://www.youtube.com/embed/owfbz9xY3qE";

  return (
    <>
      <section className={styles.heroSection}>
        <video src={coverVideo} autoPlay muted loop className={styles.heroBg} />
        <div className={styles.overlay} />
        <span className={styles.playIconContainer}>
          <img loading="lazy"  src={playIcon} alt="play-icon" className={styles.playIcon} onClick={() => setShowVideoModal(true)} />
        </span>
        <div className={styles.leftSection}>
          <div className={styles.containerBox}>
            <div className={styles.logoContainer}>
              <img loading="lazy"  src={enchantedLogo} className={styles.enchantedLogo} alt="enchanted-logo" />
              <a href={brochurePdfUrl} ref={brochurePdfUrlRef} style={{display: "none"}} download />
              <div onClick={() => setShowBrochureModal(true)}
                className={styles.downloadBrochureBtn}
              >
                Download Brochure
              </div>
              <div 
                className={styles.downloadBrochureBtn + " " + styles.showMobile}
                onClick={() => setShowVideoModal(true)}
              >
                Play Video
              </div>
              <div className={styles.reraNumber} style={{ userSelect: "none", cursor: "pointer" }} onClick={() => setShowReraModal(true)}>
              TN/29/Building/0054/2025 Dated: 13/02/2025
              </div>
              <span className={styles.reraNumber} style={{ userSelect: "none" }}>www.rera.tn.gov.in</span>
            </div>
          </div>
        </div>
      </section>
      <ReraModal
        showReraModal={showReraModal}
        setShowReraModal={setShowReraModal}
      />
      <BrochureModal
        brochurePdfUrlRef={brochurePdfUrlRef}
        showBrochureModal={showBrochureModal}
        setShowBrochureModal={setShowBrochureModal}
      />
      <VideoModal
        videoUrl={videoUrl}
        showVideoModal={showVideoModal}
        setShowVideoModal={setShowVideoModal}
      />
    </>
  );
}

export default HeroSection;
